import React from "react";
import { Box } from "@curves/ui-base";

const ActivityRecordCardActions = ({ children }) => {
	if (!children) return null;

	return (
		<Box className="activity-record-card__actions">
			{children}
		</Box>
	);
};

export default ActivityRecordCardActions;
